
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

var script = {
  name: 'CollapseTransition',
  functional: true,
  props: {
    appear: Boolean
  },

  render(h, {
    props,
    children
  }) {
    const data = {
      props: {
        name: 'pendo-transition-collapse',
        appear: props.appear
      },
      on: {
        enter(element) {
          const _getComputedStyle = getComputedStyle(element),
                width = _getComputedStyle.width;

          element.style.width = width;
          element.style.position = 'absolute';
          element.style.visibility = 'hidden';
          element.style.height = 'auto';

          const _getComputedStyle2 = getComputedStyle(element),
                height = _getComputedStyle2.height;

          element.style.width = null;
          element.style.position = null;
          element.style.visibility = null;
          element.style.height = 0;
          getComputedStyle(element).height;
          requestAnimationFrame(() => {
            element.style.height = height;
          });
        },

        afterEnter(element) {
          element.style.height = 'auto';
        },

        leave(element) {
          const _getComputedStyle3 = getComputedStyle(element),
                height = _getComputedStyle3.height;

          element.style.height = height;
          getComputedStyle(element).height;
          requestAnimationFrame(() => {
            element.style.height = 0;
          });
        }

      }
    };
    return h('transition', data, children);
  }

};

const __vue_script__ = script;
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = undefined;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "collapse-transition.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var CollapseTransition = __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export { CollapseTransition as C };
